import React, { memo, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Alert, Typography } from 'antd';

import { VERTICAL_URL } from 'settings';
import Modal from 'v2/components/Shared/Modal';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const ModalOwnership = memo(() => {
  const history = useHistory();

  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(prev => !prev), []);

  function onClose() {
    toggle();
  }

  function onProceed() {
    const userHasRemoveNewBankAccountsBeta = eduzzAccountsService.verifyUserHasBetaModule('remove_new_bank_accounts');

    if (userHasRemoveNewBankAccountsBeta) {
      history.push('/producer/profile/bankdata');
      return;
    }

    window.location.href = `${VERTICAL_URL}/bank-accounts/`;
  }

  React.useEffect(() => {
    if (user?.show_account_owner_change_modal) {
      toggle();
    }
  }, [toggle, user]);

  return (
    <Modal
      size='xs'
      open={open}
      setClose={onClose}
      textTitle='Atenção'
      textReturnButton=''
      textProceedButton='Ir para Dados Bancários'
      handleProceedClick={onProceed}
      hideReturnButton
    >
      <div className='flex flex-col gap-3'>
        <Alert
          type='warning'
          showIcon
          message={
            <>
              Após a troca de titularidade, as contas bancárias serão{' '}
              <Typography.Text strong>canceladas</Typography.Text> para a sua segurança.
            </>
          }
        />
        <Typography.Paragraph className='mb-0'>
          Você pode cadastrar sua nova conta bancária de forma{' '}
          <Typography.Text strong>simples e rápida</Typography.Text>, basta clicar em{' '}
          <Typography.Text strong>Ir para Dados bancários</Typography.Text> e depois em{' '}
          <Typography.Text strong>Cadastrar nova conta</Typography.Text>.
        </Typography.Paragraph>
        <Typography.Paragraph className='mb-0'>
          Qualquer dúvida, entre em contato com o nosso suporte. Estamos à disposição!
        </Typography.Paragraph>
      </div>
    </Modal>
  );
});

export default ModalOwnership;
